"use strict";

import ScrollHint from "scroll-hint";
import "scroll-hint/css/scroll-hint.css";

function tableScrollHint() {
  new ScrollHint(".js-scrollable", {
    applyToParents: true,
    i18n: {
      scrollable: "スクロールできます",
    },
  });
}

export { tableScrollHint };
